<template>
    <main class="m-faq">
        <div class="m-faq__hero">
            <h1
                class="m-faq__hero__title"
                v-html="textReplacer(faqTitle, 'hero-title-primary')"
            />
            <div
                v-if="faqContent"
                class="m-faq__content-wrapper"
            >
                <y-sidebar
                    :items="faqContent"
                    :default-value="faqContent[order].id"
                    @sidebar-order-option="setOrder"
                />
                <y-scrollbar
                    :items="faqContent"
                    :default-value="faqContent[order].id"
                    @sidebar-order-option="setOrder"
                />

                <div class="m-faq__questions">
                    <y-faq-accordion
                        v-for="(item, i) in faqContent[order].children"
                        :key="item.id"
                        :number="i"
                        :item="item"
                        :title-tag="'h2'"
                    />
                    <div v-show="results && showAll">
                        <div
                            v-for="(question , index) in results.length"
                            :key="question.title"
                        >
                            <y-faq-accordion
                                v-for="(item, i) in results[index]"
                                :key="item.id"
                                :number="i"
                                :item="item"
                                :title-tag="'h2'"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
// Mixins
    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Helper
    import { textReplacer } from '@/helpers/helpers';

    // Components
    import YSidebar from '@modules/faq/components/Sidebar/index.vue';
    import YFaqAccordion from '@components/FaqAccordion/Index.vue';
    import YScrollbar from '../components/Scrollbar/index.vue';

    export default {
        name: 'Faq',

        components: {
            YSidebar,
            YFaqAccordion,
            YScrollbar,
        },

        mixins: [PageMixin],

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.hero.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.hero.seo_meta_description,
                    },
                ],
            };
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                faqContent    : null,
                sidebarContent: null,
                order         : 0,
                results       : null,
                showAll       : false,
                hero          : '',
            };
        },

        computed: {
            /**
             * Return colored faq title
             *
             * @returns {string}
             */
            faqTitle() {
                return this.textReplacer(this.$settings('content.faq-page-title'), 'hero-title-primary');
            },
        },

        watch: {
            /**
             * check the order
             */
            order() {
                this.removeDuplicateQuestions();
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            textReplacer,

            /**
             * remove duplicate questions
             */
            removeDuplicateQuestions() {
                const renderedQuestion = this.faqContent[this.order].children;
                const allquestions = this.faqContent.map((item) => item.children);
                this.results = allquestions.filter((question) => question !== renderedQuestion );
            },

            /**
             * index of sidebar option
             *
             * @param {number} index
             */
            setOrder(index) {
                this.order = index;
            },

            /**
             * fetch faq content
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-faq');
                const faq = this.$services.ContentThemes.faqList({
                    slug     : 'faq-page',
                    lang     : this.$i18n.locale,
                    including: ['id', 'title', 'children', 'image'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const hero = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'faq',
                    including: ['seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([faq, hero])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.faqContent = responses[0].data.results.slice(0, -1);
                            this.removeDuplicateQuestions();
                        }
                        if (this.handleReq(responses, 1)) {
                            this.hero = responses[1].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-faq');
                    });
            },
        },
    };
</script>

<style lang="scss" src="../scss/faq.scss" />
